export const useMiCuentaPage = () => {
  const setMiCuentaState = (isOpen) => {
    localStorage.setItem("MiCuentaState", isOpen);
  };
  const getMiCuentaState = () => {
    return localStorage.getItem("MiCuentaState");
  };
  const setMiCuentaLocation = (location, option) => {
    localStorage.setItem(
      "MiCuentaLocation",
      JSON.stringify({ location: location, option: option })
    );
  };
  const getMiCuentaLocation = () => {
    return JSON.parse(localStorage.getItem("MiCuentaLocation"));
  };

  return {
    setMiCuentaState,
    getMiCuentaState,
    setMiCuentaLocation,
    getMiCuentaLocation,
  };
};
